import {formatPounds} from "../../../utils/currency";
import {observe} from "../utils/scripts";

export const updateRewardsCalculator = (el: HTMLInputElement) => {
  const rentEl = document.getElementById("calculator-rent") as HTMLInputElement;
  const pointsEl = document.getElementById("calculator-points");
  const valueEl = document.getElementById("calculator-value");

  const getPointsMultiplier = () => {
    const source = document.querySelector('input[name="source"]:checked') as HTMLInputElement;
    return source.value === "scraye" ? 1.5 : 1;
  };

  const render = () => {
    const rent = Number.parseInt(rentEl.value);
    const term = Number.parseInt((el as HTMLInputElement).value);
    const points = rent * term * getPointsMultiplier();

    if (pointsEl) {
      pointsEl.textContent = Number.isNaN(points) ? "-" : Math.floor(points).toLocaleString("en-GB");
    }
    if (valueEl) {
      valueEl.textContent = Number.isNaN(points) ? "-" : formatPounds(points / 100, "pounds", true);
    }
  };

  //init values
  render();

  rentEl.addEventListener("input", render);
  el.addEventListener("input", render);

  const radioEl = document.querySelectorAll('input[name="source"]');
  for (const radio of radioEl) {
    radio.addEventListener("change", render);
  }
};

observe("#calculator-term", (el, added) => {
  if (added) {
    updateRewardsCalculator(el as HTMLInputElement);
  }
});

const initRangeCalculator = () => {
  const valueEl = document.querySelector("#calculator-value");
  const rentEl = document.querySelector("#calculator-rent") as HTMLInputElement;

  const render = () => {
    const rent = Number.parseInt(rentEl.value);
    if (Number.isNaN(rent) || rent / 100 < 1) {
      if (valueEl) {
        valueEl.textContent = "1.5%";
      }
      return;
    }

    const value = rent / 100;
    if (valueEl) {
      valueEl.textContent = `${formatPounds(value * 1.5, "pounds", true)}`;
    }
  };

  render();
  rentEl.addEventListener("input", render);
};

observe("[data-init-rewards-range-calculator]", (_, added) => {
  if (added) {
    initRangeCalculator();
  }
});
